"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.technicalImpressionsList = void 0;
const gi_1 = require("react-icons/gi");
const md_1 = require("react-icons/md");
const fi_1 = require("react-icons/fi");
const React = require("react");
const general_impression_config_1 = require("./config/general-impression.config");
exports.technicalImpressionsList = [
    {
        id: 0,
        title: 'Cuidado!',
        subtitle: 'Euforia de compras',
        description: 'Foi detectado um fluxo de compras fora do normal no momento, cuidado com as emoções.',
        icon: React.createElement(gi_1.GiPayMoney, { size: general_impression_config_1.impressionConfig.size }),
        iconColor: '#fdd835',
        importantLevel: 80,
        reportableIdentification: 'EUFORIA_COMPRAS',
    },
    {
        id: 1,
        title: 'Cuidado!',
        subtitle: 'Euforia de vendas',
        description: 'Foi detectado um fluxo de vendas fora do normal no momento, cuidado com as emoções.',
        icon: React.createElement(gi_1.GiReceiveMoney, { size: general_impression_config_1.impressionConfig.size }),
        iconColor: general_impression_config_1.impressionConfig.colors.warning,
        importantLevel: 80,
        reportableIdentification: 'EUFORIA_VENDAS',
    },
    {
        id: 2,
        title: 'Cuidado!',
        subtitle: 'Maré Alta',
        description: 'Foi detectado uma alta volatilidade no período, preço sem estabilidade e entradas perigosas, que tal esperar as ondas baixarem?',
        icon: React.createElement(gi_1.GiPaperBoat, { size: general_impression_config_1.impressionConfig.size }),
        iconColor: general_impression_config_1.impressionConfig.colors.warning,
        importantLevel: 80,
        reportableIdentification: 'MARE_ALTA',
    },
    {
        id: 3,
        title: 'Boa Indicação',
        subtitle: 'Técnica',
        description: 'Ao analisar os gráficos e utilizar padrões de análises técnicas avançadas, grande maioria indicou sua compra!',
        icon: React.createElement(md_1.MdOutlineStackedLineChart, { size: general_impression_config_1.impressionConfig.size }),
        iconColor: general_impression_config_1.impressionConfig.colors.good,
        importantLevel: 80,
        reportableIdentification: 'BOA_INDICACAO_TECNICA',
    },
    {
        id: 4,
        title: 'Baixa Indicação',
        subtitle: 'Técnica',
        description: 'Ao analisar o gráfico e utilizar padrões de análises técnicas avançadas, grande maioria indicou sua venda!',
        icon: React.createElement(fi_1.FiBarChart2, { size: general_impression_config_1.impressionConfig.size }),
        iconColor: general_impression_config_1.impressionConfig.colors.danger,
        importantLevel: 80,
        reportableIdentification: 'BAIXA_INDICACAO_TECNICA',
    },
    {
        id: 5,
        title: 'MACD',
        subtitle: 'Bom nível',
        description: 'Ao utilizar padrões de análises avançadas foi possível observar o nível de MACD (12,26) deste ativo indicando sua compra!',
        icon: React.createElement(md_1.MdMultilineChart, { size: general_impression_config_1.impressionConfig.size }),
        iconColor: general_impression_config_1.impressionConfig.colors.good,
        importantLevel: 75,
        reportableIdentification: 'BOM_MACD',
    },
    {
        id: 6,
        title: 'MACD',
        subtitle: 'Nível Médio',
        description: 'Ao utilizar padrões de análises avançadas foi possível observar o nível de MACD (12,26) deste ativo indicando sua venda!',
        icon: React.createElement(md_1.MdMultilineChart, { size: general_impression_config_1.impressionConfig.size }),
        iconColor: general_impression_config_1.impressionConfig.colors.warning,
        importantLevel: 80,
        reportableIdentification: 'MEDIO_MACD',
    },
];
//# sourceMappingURL=technical-impressions.data.js.map